import './App.css';
import Console from './components/Console';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Console />
      <Footer />
    </div>
  );
}

export default App;